module.exports = __webpack_public_path__ + "img/lamp_xd.ccb21b21.png";